<script>
import isPlainObject from 'lodash/isPlainObject'
import set from 'lodash/set'
import { globalVariablesMixin } from '../../../Mixins/global'
import jsonRequestMixins from '../../../Mixins/jsonRequestMixins'
import { testPattern } from '../../../../Utils/regexUtils'

export default {
  mixins: [globalVariablesMixin, jsonRequestMixins],

  props: {
    id: { type: [Number, String, null], default: null, required: false },
    uuid: { type: [String, null, undefined], default: null, required: false },
    srcError: { type: String, default: null },
    method: { type: String, default: null },
    endpoint: { type: String, required: false, default: '' },
    params: { type: Object, required: false },
    sendParams: { type: Boolean, default: false },
    useIdInDef: { type: Boolean, default: false },
    classToAdd: { type: String, required: false },
    inModal: { type: Boolean, default: false },
    getForced: { type: Boolean, default: false },
    configObject: { type: Object, required: false },
    dynamic: { type: Boolean, default: false },
    configDef: { type: Object, required: false },
    specificEndpoint: { type: String, required: false },
    disabled: { type: Boolean, required: false, default: false },
    submitDisabled: { type: Boolean, default: false },
    name: { type: String, required: false },
    noWaitingModal: { type: Boolean, default: false },
  },
  emits: [
    'is-sending',
    'is-loading',
    'modal-build',
    'modal-error',
    'form-return',
    'form-build',
    'form-error',
    'update-data',
    'global-build',
    'element-build',
    'def-build',
    'object-build',
    'object-return',
    'error',
    'error-return',
    'update',
    'update:unit',
    'update:platformSalesman',
    'refresh-return',
    'validate',
  ],
  data() {
    return {
      fields: {},
      datas: {},
      def: {},
      object: {},
      errors: {},
      datasToRemove: {},
      message: {},
      inject: [],
      request: this.method || (this.id ? 'patch' : 'post'),
      specificEndpointData: { type: String, required: false },
      showErrors: false,
    }
  },
  computed: {
    defParamsDefined() {
      return Object.keys(this.params ?? {}).length > 0
    },
  },
  methods: {
    arrayGet(list, key, obj = null) {
      let listBefore = list
      if (key.includes('.')) {
        let keys = key.split('.')
        for (let j in keys) {
          let next = keys[j]
          list = list[next]
          if (list == undefined && obj) {
            list = listBefore[obj][next]
          }
        }
        return list
      } else {
        return list[key]
      }
    },
    checkIfFieldsAreDisabledRecursively(obj) {
      return Object.values(obj).every((field) => {
        if (field.options) {
          return field.options.disabled === true
        }
        if (typeof field === 'object') {
          return this.checkIfFieldsAreDisabledRecursively(field)
        }
        return false
      })
    },
    toJSON(date) {
      let newDate = new Date(0)
      newDate.setUTCFullYear(date.getFullYear())
      newDate.setUTCMonth(date.getMonth())
      newDate.setUTCDate(date.getDate())
      return newDate.toJSON()
    },
    methods(forceMethod, reload = null, methodEndpoint = null, endpointOverride = null) {
      let obj = {}

      for (let field in this.datas) {
        defField = this.arrayGet(this.def, field)

        if (defField) {
          switch (true) {
            case defField.type === 'number': {
              if (this.datas[field] === '') {
                this.datas[field] = null
              }

              break
            }
            case defField.type === 'date': {
              if (this.datas[field] !== undefined && this.datas[field] !== null) {
                let chunks = this.datas[field].split('/')
                if (chunks.length > 1) {
                  let formattedDate = new Date(chunks[1] + '/' + chunks[0] + '/' + chunks[2])
                  value = this.toJSON(formattedDate)
                } else {
                  value = chunks[0]
                }
                this.datas[field] = value
              }
              break
            }
            case defField['0']: {
              for (const [collectionIndex, collectionFields] of Object.entries(defField)) {
                for (const [name, index] of Object.entries(collectionFields)) {
                  const nestedDefField = this.arrayGet(this.def, field)
                  collectionField = this.arrayGet(nestedDefField[collectionIndex], name)
                  if (collectionField && collectionField.type === 'date') {
                    if (this.datas[field][collectionIndex][name] !== undefined) {
                      let chunks = this.datas[field][collectionIndex][name].split('/')
                      if (chunks.length > 1) {
                        let formattedDate = new Date(chunks[1] + '/' + chunks[0] + '/' + chunks[2])
                        value = this.toJSON(formattedDate)
                      } else {
                        value = chunks[0]
                      }
                      this.datas[field][collectionIndex][name] = value
                    }
                  }
                }
              }
              break
            }
            default: {
              break
            }
          }
        }
      }

      for (const [keyRemove, i] of Object.entries(this.datasToRemove)) {
        if (typeof this.datasToRemove[keyRemove] == 'object') {
          for (const [collectionIndex, collectionElement] of Object.entries(this.datasToRemove[keyRemove])) {
            for (const [name, y] of Object.entries(this.datasToRemove[keyRemove][collectionIndex])) {
              delete this.datas[keyRemove][collectionIndex][name]
            }
          }
        } else {
          delete this.datas[keyRemove]
        }
      }

      this.emptyObject(this.datasToRemove)

      obj = this.valueAsArray(this.datas)

      if (this.endpoint === 'equipments') {
        obj['main'] = this.params.mainId
      }

      if (['services', 'commissions', 'surrenders', 'v2/surrenders'].includes(this.endpoint)) {
        obj['financeId'] = this.params.financeId
      }

      if (this.endpoint === 'comments') {
        obj['context'] = this.params.context
        obj['contextId'] = this.params.contextId
      }

      let request = forceMethod || this.request
      let errors = []

      if (request !== 'force' && request !== 'update') {
        let valid = this.isValid(forceMethod)
        request = valid.request
        errors = valid.errors
      }

      if (request !== 'force' && this.inject['error'] !== undefined) {
        request = 'inject'
      }
      const handlers = {
        post: () => this.post(obj, methodEndpoint, endpointOverride),
        get: () => this.get(),
        refresh: () => this.refresh(obj, reload),
        update: () => this.update(obj, reload),
        patch: () => this.patch(obj, reload, methodEndpoint),
        force: () => this.patch(obj, reload),
        delete: () => this.delete(obj),
        inject: () => this.injectError(),
        default: () => this.handleError(errors),
      }

      return (handlers[request] || handlers.default)()
    },
    post(datas, methodEndpoint, endpointOverride = null) {
      this.$emit('object-return', { sending: true, object: null, context: 'post' })
      this.$emit('is-sending', true)
      let url = endpointOverride ?? this.endpoint
      if (!!this.specificEndpoint && !methodEndpoint) {
        url += '/' + this.specificEndpoint
      } else if (methodEndpoint) {
        url += '/' + methodEndpoint
      }
      if (this.sendParams) {
        for (let key in this.params) {
          if (this.params.hasOwnProperty(key)) {
            datas[key] = this.params[key]
          }
        }
      }
      return this.postJSON(this.freeUrl(url), datas, null).then(
        (json) => {
          this.$root.setValue(this, 'object', json)

          this.$emit('object-return', { sending: false, object: json, context: 'post' })
          this.$emit('is-sending', false)
          this.$emit('form-return', json, { datas, params: this.params })
          return true
        },
        (reason) => {
          this.$emit('object-return', { sending: false, object: null, context: 'post', error: true })
          this.$emit('is-sending', false)
          this.$emit('modal-error', true)
          this.$emit('form-error', true)
          return false
        },
      )
    },
    dynamicGet() {
      if (this.configObject && this.configDef) {
        if (Object.keys(this.configObject).length > 0 && Object.keys(this.configDef).length > 0) {
          this.def = this.applyDisabledState(this.configDef)
          this.object = this.configObject
          this.resetFormState()

          this.$emit('update-data', this)
          this.$emit('global-build', { loading: false, build: true, def: this.def, object: this.object })

          this.$emit('form-build', true)
          this.$emit('element-build', this.def, this.object)
          this.$emit('def-build', this.def)
          this.$emit('object-build', this.object)
          this.$emit('is-loading', false)
        }
      }
    },
    get() {
      this.$emit('global-build', { loading: true, build: false, def: {}, object: {} })
      this.$emit('is-loading', true)
      let url = this.endpoint

      if (!this.useIdInDef && this.params && Object.keys(this.params).length > 0) {
        url += '/def'
      } else if (!!this.id) {
        url += '/' + this.id + '/def'
      } else if (!!this.specificEndpoint) {
        url += '/' + this.specificEndpoint
      }

      if (this.defParamsDefined) {
        const queryParams = {}
        for (const property in this.params) {
          const value = this.params[property]
          if (value !== null && (!Array.isArray(value) || value.length > 0)) {
            queryParams[property] = this.params[property]
          }
        }

        url += `?${new URLSearchParams(queryParams).toString()}`
      }

      return this.getJSON(this.freeUrl(url)).then((json) => {
        // Values from the previous def would be validated against the new one (e.g. hidden required fields)
        this.datas = {}
        this.datasToRemove = {}
        this.def = this.applyDisabledState(json.config)
        const { object, contract, simulation, equipment, demand, rent, deliveryOrder, message, entity } = json
        const objectTypes = { object, contract, simulation, equipment, demand, rent, deliveryOrder, message, entity }
        this.object = Object.values(objectTypes).find(Boolean)

        this.$emit('update-data', this)

        if (this.inModal) {
          this.$emit('modal-build')
        }

        this.$emit('global-build', { loading: false, build: true, def: this.def, object: this.object })

        this.$emit('form-build', true)
        this.$emit('element-build', this.def, this.object)
        this.$emit('def-build', this.def)
        this.$emit('object-build', this.object)
        this.$emit('is-loading', false)
        if (Object.keys(this.errors).length > 0) {
          this.errors = {}
        }
      })
    },
    patch(datas, reload, methodEndpoint) {
      this.$emit('object-return', { sending: true, object: null, context: 'patch' })
      this.$emit('is-sending', true)

      let url = this.endpoint
      if (!!this.id) {
        url += '/' + this.id
      }

      if (this.specificEndpoint && !methodEndpoint) {
        url += '/' + this.specificEndpoint
      } else if (methodEndpoint) {
        url += '/' + methodEndpoint
      }

      if (this.sendParams) {
        for (let key in this.params) {
          if (this.params.hasOwnProperty(key)) {
            const value = this.params[key]

            datas[key] = value
          }
        }
      }
      return this.patchJSON(this.freeUrl(url), datas, {
        noWaitingModal: this.noWaitingModal,
      }).then(
        (json) => {
          this.$emit('object-return', { sending: false, object: json, context: 'patch' })
          this.$emit('is-sending', false)
          this.$emit('form-return', json, { datas, params: this.params })
          if (reload) {
            location.reload()
          }
          return true
        },
        (reason) => {
          this.$emit('is-sending', false)
          this.$emit('error', reason)
          return false
        },
      )
    },
    refresh(datas, reload) {
      this.$emit('is-sending', true)
      let url = this.endpoint + '/' + this.id
      datas['refreshForm'] = true
      return this.patchJSON(this.freeUrl(url), datas, this.message).then(
        (json) => {
          this.$emit('is-sending', false)
          this.def = this.applyDisabledState(json.config)
          const { object, contract, simulation, equipment, demand, rent, deliveryOrder } = json
          const objectTypes = { object, contract, simulation, equipment, demand, rent, deliveryOrder }
          this.object = Object.values(objectTypes).find(Boolean)

          this.$emit('update-data', this)

          this.$emit('update:unit', this.object.unit)
          this.$emit('update:platformSalesman', this.object.platformSalesman)

          if (this.inModal) {
            this.$emit('modal-build')
          }

          this.$emit('form-build', true)
          this.$emit('def-build', this.def)
          this.$emit('refresh-return', this.object)
          if (reload) {
            location.reload()
          }
        },
        (reason) => {
          this.$emit('is-sending', false)
        },
      )
    },
    update(datas, reload) {
      let url = this.endpoint + '/refresh'
      if (this.params && Object.keys(this.params).length > 0) {
        url += '?' + new URLSearchParams(this.params).toString()
      }

      return this.patchJSON(this.freeUrl(url), datas, this.message).then((json) => {
        this.object = json
        this.$emit('update', json)
      })
    },
    delete(datas) {
      let url = this.endpoint + '/' + this.id
      if (this.sendParams) {
        for (let key in this.params) {
          if (this.params.hasOwnProperty(key)) {
            const value = this.params[key]

            datas[key] = value
          }
        }
      }
      return this.deleteJSON(url, datas, this.message).then(
        (json) => {
          this.$emit('form-return', { id: this.id }, { datas, params: this.params })
        },
        (reason) => {
          this.$emit('is-sending', false)
        },
      )
    },
    freeUrl(url) {
      if (!this.uuid) {
        return url
      }

      const separator = url.includes('?') ? '&' : '?'
      return `free/${url}${separator}uniqid=${this.uuid}`
    },
    isValid(forceMethod = null) {
      let request = forceMethod || this.request
      let errors = []

      // Clear error message text and feedback from DOM, but keep the error flags
      document.querySelectorAll('[id^="invalid-feedback-"]').forEach(function (element) {
        element.textContent = ''
      })
      for (const [keyData, data] of Object.entries(this.datas)) {
        for (const [keyError, error] of Object.entries(this.errors)) {
          if (keyData === keyError) {
            if (error === true) {
              const fieldDef = this.arrayGet(this.def, keyData)
              const isRequired = fieldDef?.options?.required
              const hasPattern = fieldDef?.options?.constraints?.pattern
              const isEmpty = data === null || data === undefined || data === ''
              if (hasPattern && !isEmpty && !testPattern(hasPattern, data) && fieldDef.type === 'text') {
                errors.push({
                  fieldName: keyData,
                  type: 'pattern',
                })
                request = 'failed'
              } else if (isRequired && isEmpty) {
                errors.push({
                  fieldName: keyData,
                  type: 'required',
                })
                request = 'failed'
              }
            }

            if (error['0']) {
              error.map((collectionFields, collectionIndex) => {
                for (const [fieldName, fieldRequired] of Object.entries(collectionFields)) {
                  if (fieldRequired) {
                    if (errors[keyData]) {
                      errors[keyData][collectionIndex].push(fieldName)
                    } else {
                      let arrIndex = []
                      let arrName = [fieldName]
                      arrIndex[collectionIndex] = arrName
                      errors[keyData] = arrIndex
                    }
                    request = 'failed'
                  }
                }
              })
            }
          }
        }
      }

      this.$emit('validate', this.datas, (error) => {
        if (!error || error.length === 0) {
          return
        }

        request = 'failed'

        if (Array.isArray(error)) {
          error.forEach((err) => {
            if (!errors.find((e) => e.fieldName === err.fieldName)) {
              errors.push(err)
              this.errors[err.fieldName] = true
            }
          })

          return
        }

        if (!errors.find((e) => e.fieldName === error.fieldName)) {
          errors.push(error)
          this.errors[error.fieldName] = true
        }
      })

      return { request, errors }
    },
    handleError(errors) {
      this.showErrors = true
      this.$emit('object-return', { sending: false })
      this.$emit('is-sending', false)
      this.$emit('error-return', errors)
      let firstError = null
      const errorTypeMessages = {
        pattern: 'main.formValueFormatInvalid',
        required: 'main.formError',
      }
      errors.forEach((error) => {
        const fieldName = error.fieldName || error
        const nameField = fieldName.split('.').join('-')
        const errorMessage = error.message || errorTypeMessages[error.type] || 'main.formError'
        let inputId = document.getElementById(`nameField${this.srcError ?? ''}`)
        if (inputId) {
          inputId?.classList.add('is-invalid')
          if (!firstError) {
            firstError = inputId
          }
        }
        let divErrorId = document.getElementById(`invalid-feedback-${nameField}`)
        if (divErrorId) {
          divErrorId.textContent = this.$t(errorMessage)
        }
      })
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
      }
    },
    injectError() {
      this.showErrors = true
      this.$emit('object-return', { sending: false })
      this.$emit('is-sending', false)
      let firstError = null
      this.inject.map((error) => {
        const nameField = error.fieldName.split('.').join('-')
        const inputId = document.getElementById(nameField + (this.srcError ?? ''))
        if (inputId) {
          inputId?.classList.add('is-invalid')
          if (!firstError) {
            firstError = inputId
          }
        }
        const divErrorId = document.getElementById(`invalid-feedback-${nameField}`)
        if (divErrorId) {
          divErrorId.textContent = this.$t(error.message)
        }
      })
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
      }
    },
    emptyObject(objet) {
      for (var propriete in objet) {
        if (objet.hasOwnProperty(propriete)) {
          delete objet[propriete]
        }
      }
    },
    applyDisabledState(def) {
      if (!this.disabled) {
        return def
      }

      for (const property in def) {
        if (!isPlainObject(def[property])) {
          continue
        }

        if (!def[property].hasOwnProperty('options')) {
          def[property] = this.applyDisabledState(def[property])
        } else {
          def[property]['options']['disabled'] = true
        }
      }

      return def
    },
    resetFormState() {
      this.showErrors = false
      this.errors = {}
    },
    areAllFieldsDisabled() {
      return this.checkIfFieldsAreDisabledRecursively(this.def)
    },
    setFormData(key, value) {
      set(this.datas, key, value)
    },
    setObjectValue(key, value) {
      set(this.object, key, value)
    },
    setObject(object) {
      this.object = object
    },
  },
  watch: {
    configObject: {
      handler: function () {
        this.dynamicGet()
      },
      deep: true,
    },
  },
  beforeMount() {
    if (this.method === 'delete' && !this.getForced) {
      const params = this.params || { id: this.id }
      this.delete(params)
    } else if (this.dynamic) {
      this.dynamicGet()
    } else {
      this.get()
    }
  },
}
</script>
<template>
  <button
    type="button"
    :class="'btn btn-primary ' + classToAdd"
    :disabled="submitDisabled"
    @click="methods()"
    :e2e-button="name"
  >
    <slot></slot>
  </button>
</template>
